import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-757ca6a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["media", "sizes", "srcset"]
const _hoisted_3 = ["srcset"]
const _hoisted_4 = ["alt", "height", "src", "title", "width"]
const _hoisted_5 = ["data-icon"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.image || _ctx.icon)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([{'card-img--image': _ctx.image, 'card-img--icon': _ctx.icon}, "card-img-top"])
      }, [
        (_ctx.image)
          ? (_openBlock(), _createElementBlock("picture", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.image.sources, (source) => {
                return (_openBlock(), _createElementBlock("source", {
                  key: source.srcset,
                  media: source.media,
                  sizes: source.sizes,
                  srcset: source.srcset
                }, null, 8, _hoisted_2))
              }), 128)),
              _createElementVNode("source", {
                srcset: _ctx.image.img.srcset
              }, null, 8, _hoisted_3),
              _createElementVNode("img", {
                alt: _ctx.image.alt,
                class: _normalizeClass(_ctx.image.img.class),
                height: _ctx.image.img.height,
                src: _ctx.image.img.src,
                title: _ctx.image.title,
                width: _ctx.image.img.width
              }, null, 10, _hoisted_4)
            ]))
          : (_ctx.icon)
            ? (_openBlock(), _createElementBlock("i", {
                key: 1,
                "data-icon": _ctx.dataIconValue,
                class: "fcb-icon path-segment-icon"
              }, null, 8, _hoisted_5))
            : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}